@import 'styles/mixins';
@import 'styles/variables';

$container-height: 320;

.container {
  align-items: center;
  position: relative;
  width: calc(100% - 32px);
  height: $container-height * 1px;
  margin: 12px 16px;

  &.dragging {
    cursor: grabbing;
  }

  &:hover {
    .buttonsGroup {
      display: flex;
    }
  }

  &.inCore {
    margin: 0;
    width: 100%;

    .imageContainer {
      border-radius: 0px;
    }
  }
}

.image {
  display: block;
  width: 100%;
  object-fit: cover;
  height: 320px;
  object-position: center 50%;
}

.imageContainer {
  overflow: hidden;
  width: 100%;
  max-height: $container-height * 1px;
  border-radius: 8px;
}

.controlsContainer {
  display: flex;
  position: absolute;
  bottom: 0;
  left: 16px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 100%;

  &.repositioning {
    pointer-events: none;
  }
}

.buttonsGroupContainer {
  position: relative;
  width: 100%;
  height: 40px;
  max-width: 750px;
  margin-bottom: 4px;
}

.buttonsGroup {
  display: none;
  position: absolute;
  pointer-events: all;
}

.actionButton {
  @include btn-sm-text;
  margin-right: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  color: $gray-90;
  background-color: $white;

  &:hover {
    background-color: $white-off;
  }
}

.hide {
  display: none;
}

.spinner {
  position: absolute;
  left: 50%;
  top: 45%;
}

.mediaPrompt {
  position: absolute;
  top: 0;
  left: 0;
}

.repositioningInfo {
  background: rgba(19, 21, 26, 0.5);
  border-radius: 4px;
  display: flex;
  padding: 6px 8px;
  position: absolute;
  top: 50%;

  span {
    @include btn-sm-text;
    color: $white;
  }
}

// Exports
@value containerHeight #{$container-height};

@media (min-width: $tabletPortraitMinWidth) {
  .container {
    top: $layers-tabs-height;
  }
}
